import React, { Suspense, lazy } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import ScrollToTop from './components/ScrollToTop';
import ErrorBoundary from './components/ErrorBoundary';
import './App.css';

// ===== 路由级懒加载 =====
const LandingPage = lazy(() => import('./LandingPage'));
const YuesaoPage = lazy(() => import('./YuesaoPage'));
const YuyingshiPage = lazy(() => import('./YuyingshiPage'));
const AuntDetailPage = lazy(() => import('./AuntDetailPage'));
const AdminPage = lazy(() => import('./AdminPage'));
const NewAboutPage = lazy(() => import('./NewAboutPage'));
const AboutPage = lazy(() => import('./AboutPage'));
const AuntGalleryPage = lazy(() => import('./AuntGalleryPage'));
const NotFoundPage = lazy(() => import('./components/NotFoundPage'));

/** 路由加载中的 Loading */
const PageLoading = () => (
  <div style={{
    minHeight: '100vh',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    background: '#FFF9F2',
  }}>
    <div className="warm-loader">
      <div className="orbit">
        <div className="ring"></div>
        <div className="heart"></div>
        <div className="dot"></div>
        <div className="dot"></div>
        <div className="dot"></div>
      </div>
      <div className="text-main">
        加载中<span className="dots-animated"></span>
      </div>
      <div className="text-sub">康丽恩 · 用心为您甄选</div>
    </div>
  </div>
);

/** 每个路由独立包裹 ErrorBoundary，一个页面出错不影响其他页面 */
function SafePage({ children }) {
  return <ErrorBoundary>{children}</ErrorBoundary>;
}

function App() {
  return (
    <BrowserRouter>
      <ScrollToTop />
      <Suspense fallback={<PageLoading />}>
        <Routes>
          <Route path="/" element={<SafePage><LandingPage /></SafePage>} />
          <Route path="/yuesao" element={<SafePage><YuesaoPage /></SafePage>} />
          <Route path="/yuyingshi" element={<SafePage><YuyingshiPage /></SafePage>} />
          <Route path="/aunt" element={<SafePage><AuntGalleryPage /></SafePage>} />
          <Route path="/aunt/:id" element={<SafePage><AuntDetailPage /></SafePage>} />
          <Route path="/admin" element={<SafePage><AdminPage /></SafePage>} />
          <Route path="/about" element={<SafePage><NewAboutPage /></SafePage>} />
          <Route path="/about-old" element={<SafePage><AboutPage /></SafePage>} />
          <Route path="/aunts" element={<SafePage><AuntGalleryPage /></SafePage>} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
